import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
export default function useIsWindowActive() {
  "use memo";

  const $ = _c(4);
  const [isWindowActive, setIsWindowActive] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsWindowActive(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onBlur = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsWindowActive(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onFocus = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);
      return () => {
        window.removeEventListener("blur", onBlur);
        window.removeEventListener("focus", onFocus);
      };
    };
    t3 = [onBlur, onFocus];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return isWindowActive;
}